<script setup lang="ts">
import { PaginationEllipsis, PaginationList, PaginationListItem, PaginationNext, PaginationPrev, PaginationRoot } from "reka-ui";

const page = defineModel<number>("page");
defineProps<{ itemsPerPage: number; total: number }>();
</script>

<template>
  <PaginationRoot v-if="total > itemsPerPage" v-model:page="page" :items-per-page="itemsPerPage" :total="total" show-edges :sibling-count="1">
    <PaginationList v-slot="{ items }" class="flex items-center justify-center gap-2 font-medium lg:text-xl">
      <PaginationPrev class="btn-pagination-prev">
        <span class="i-lucide-chevron-left size-6" />
      </PaginationPrev>
      <template v-for="(item, i) in items">
        <PaginationListItem v-if="item.type === 'page'" :key="i" :value="item.value" class="w-12 data-[selected=true]:text-primary" />
        <PaginationEllipsis v-else :key="item.type" :index="i" class="w-12 text-center">
          &#8230;
        </PaginationEllipsis>
      </template>
      <PaginationNext class="btn-pagination-next">
        <span class="i-lucide-chevron-right size-6" />
      </PaginationNext>
    </PaginationList>
  </PaginationRoot>
</template>
